import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';

import cn from '@/lib/clsxm';

import ModalAction from '@/components/@base/modal/action';
import ModalBody from '@/components/@base/modal/body';
import ModalHead from '@/components/@base/modal/head';
import { type Props } from '@/components/@base/modal/type';

export default function Modal({
  onClose,
  show = false,
  noBackDrop = false,
  center = false,
  darkBackDrop = false,
  children,
  dialogProps,
  className,
  dialogPanelProps,
  dialogPanelClassName,
  panelWrapperClassName,
  grayScaleBackDrop = false,
  roundHead = false,
}: Props) {
  const { className: dialogClassName, ...otherDialogProps } = dialogProps ?? {};
  const { className: otherDialogPanelClassName, ...otherDialogPanelProps } =
    dialogPanelProps ?? {};
  return (
    <Transition
      appear
      enterFrom=''
      enterTo=''
      leave=''
      leaveFrom=''
      leaveTo=''
      show={show}
      as={Fragment}
    >
      <Dialog
        as='div'
        className={cn('relative z-[100]', dialogClassName, className)}
        onClose={() => onClose?.()}
        {...otherDialogProps}
      >
        {!noBackDrop && (
          // <Transition.Child
          //   as={Fragment}
          //   enter='ease-out duration-300'
          //   enterFrom='opacity-0'
          //   enterTo='opacity-100'
          //   leave='ease-in duration-200'
          //   leaveFrom='opacity-100'
          //   leaveTo='opacity-0'
          // >
            <div
              className={cn(
                'fixed top-0 bottom-0 left-0 right-0 bg-black/45 backdrop-blur-sm'
                ,grayScaleBackDrop && 'filter grayscale'
                ,darkBackDrop && 'bg-grayLight-900',

              )}
              onClick={(e) => {
                e.preventDefault();
              }}
            />
          // </Transition.Child>
        )}

        <div className='fixed top-0 bottom-0 left-0 right-0 overflow-y-auto'>
          <div
            className={cn(
              'flex min-h-full items-end justify-center text-center md:items-center md:p-4',
              center && 'items-center',
              panelWrapperClassName,
            )}
          >
            {/*<Transition.Child*/}
            {/*  as={Fragment}*/}
            {/*  enter='ease-out duration-300'*/}
            {/*  enterFrom='opacity-0 scale-95'*/}
            {/*  enterTo='opacity-100 scale-100'*/}
            {/*  leave='ease-in duration-200'*/}
            {/*  leaveFrom='opacity-100 scale-100'*/}
            {/*  leaveTo='opacity-0 scale-95'*/}
            {/*>*/}
              <Dialog.Panel
                className={cn(
                  'w-full max-w-md overflow-hidden bg-white p-4 text-left rounded-xl align-middle sm:shadow-xl dark:bg-grayDark-900',
                  roundHead && 'rounded-t-xl',
                  center && 'w-[75%] max-w-[448px] rounded-xl',
                  otherDialogPanelClassName,
                  dialogPanelClassName,
                )}
                {...otherDialogPanelProps}
              >
                {children}
              </Dialog.Panel>
            {/*</Transition.Child>*/}
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}

export { ModalAction, ModalBody, ModalHead };
